import { Database, Layers, Table2 } from 'lucide-react';
import { Card } from '@cortex/web-design-system/components/ui/Card';
import { formatBytes, formatNumber } from '../../lib/data-catalog-format.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business データカタログのサマリーカード。BQ / Firestore / 合計の3つのカードを表示する。
 * @graph-connects none
 */
export function CatalogSummary({
  bqDatasetCount,
  bqTableCount,
  bqTotalSize,
  fsCollectionCount,
  fsTotalDocs,
}: {
  bqDatasetCount: number;
  bqTableCount: number;
  bqTotalSize: number;
  fsCollectionCount: number;
  fsTotalDocs: number;
}) {
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-3">
      <Card className="flex items-center gap-3 p-4">
        <Database className="h-5 w-5 shrink-0 text-[var(--color-accent-primary)]" />
        <div>
          <div className="text-lg font-bold text-[var(--color-text-primary)]">{bqTableCount}</div>
          <div className="text-xs text-[var(--color-text-muted)]">
            BQ {bqDatasetCount} データセット / {formatBytes(bqTotalSize)}
          </div>
        </div>
      </Card>
      <Card className="flex items-center gap-3 p-4">
        <Layers className="h-5 w-5 shrink-0 text-[var(--color-warning)]" />
        <div>
          <div className="text-lg font-bold text-[var(--color-text-primary)]">
            {fsCollectionCount}
          </div>
          <div className="text-xs text-[var(--color-text-muted)]">
            Firestore {formatNumber(fsTotalDocs)} docs
          </div>
        </div>
      </Card>
      <Card className="col-span-2 flex items-center gap-3 p-4 lg:col-span-1">
        <Table2 className="h-5 w-5 shrink-0 text-[var(--color-text-secondary)]" />
        <div>
          <div className="text-lg font-bold text-[var(--color-text-primary)]">
            {bqTableCount + fsCollectionCount}
          </div>
          <div className="text-xs text-[var(--color-text-muted)]">合計リソース</div>
        </div>
      </Card>
    </div>
  );
}
